var map = {
	"./news1.png": "UpjH",
	"./news2.png": "GA13",
	"./news3.png": "38uA",
	"./news4.png": "shcG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hdyG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news ^\.\/.*$
// module id = hdyG
// module chunks = 2